module.exports = __webpack_public_path__ + "static/RQG.d26af47e.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/RQG.png
// module id = 463
// module chunks = 246384609461072